// biome-ignore lint/complexity/noStaticOnlyClass: existing pattern
export class GaiaConstants {
  static readonly SELECTED_TEAM_NAME = "Team";
  static readonly GUEST_TEAM = "guest";
  static readonly SELECTED_TEAM_DESCRIPTION = "TeamDescription";
  static readonly SELECTED_SUB_TEAM_NAME = "SubTeam";
  // Data related pages/components
  static readonly CUSTOMER_INFORMATION_LOOKUP = "CustomerInformationLookup";
  static readonly CUSTOMER_INFORMATION_LOOKUP_BY_BRAAVOS =
    "CustomerInformationLookupByBraavos";
  static readonly SELLER_INFORMATION_LOOKUP = "SellerInformationLookup";
  static readonly BRAZIL_MARKET_PLACE_SELLER_LOOKUP =
    "BrazilMarketPlaceSellerLookup";
  static readonly BULK_UPLOAD_WORKFLOW = "BulkUploadWorkflow";
  static readonly ATLAS_CHATBOT_CONVERSATIONS_LIMIT = 10;
  static readonly ATLAS_CHATBOT_MESSAGES_LIMIT = 10;
  static readonly NOTIFICATION_TIMEOUT = {
    SHORT: 5000,
    LONG: 10000,
  };
  static readonly OPENSEARCH_SYNC_DELAY = 2500; // for DDB->OpenSearch sync
  static readonly PLACE_HOLDER = "placeholder";
  static readonly INDIA_DIRECT_TEAM = "india_direct";
  static readonly US_SALT_DIRECT_TEAM = "us_salt_direct";
  static readonly US_PROPERTY_TAX_TEAM = "us_property_tax";
  static readonly AUDIT_FILES_PREFIX = "audits";
  static readonly TEMPLATE_TEAMS = ["us_salt_direct", "us_salt_indirect"];
  static readonly TABLE_FILTER_OPERATORS = ["=", "!=", ":", "!:", "^", "!^"];
  static readonly DOCUMENT_API_BATCH_SIZE = 10;
  static readonly DOCUMENT_STORE_DISCLAIMER = "Gaia keeps files for 10 years.";
  static readonly DEFAULT_STATUS = "Not started";
  static readonly FOLDER_EXTENSION_TYPE = "Folder";
  static readonly LINK_EXTENSION_TYPE = "Link";
  static readonly DEFAULT_UNIQUE_VALUES_LIMIT = 150;
  // Draft provenance: drafts transferred in from NOVA carry an externalDocumentId,
  // drafts uploaded directly in Gaia do not.
  static readonly NOVA_SOURCE = "Nova";
  static readonly GAIA_SOURCE = "Gaia";
}

export const TEAM_NAME_MAP: {
  [key: string]: string;
} = {
  accounting: "Accounting",
  apac_accounting_compliance: "APAC Accounting Compliance",
  apac_controversy: "APAC Controversy",
  aws_emea_tax_planning: "AWS EMEA Tax Planning",
  aws_apac_tax_planning: "AWS APAC Tax Planning",
  brazil_indirect: "Brazil Indirect",
  canada: "Canada",
  gaia_dev: "Gaia Dev",
  germany_rc: "Germany R&C",
  emea_accounting_compliance: "EMEA Accounting Compliance",
  emea_stores: "EMEA Stores",
  gtd_audit: "GTD Audit",
  india_direct: "India Direct",
  india_wht: "India WHT",
  ireland_ccf: "Ireland - Tax Authority Management (CCF)",
  itx_compliance: "ITX Compliance",
  us_property_tax: "US Property Tax",
  us_state_rc: "US State R&C",
  latam_accounting_compliance: "LATAM Accounting Compliance",
  us_fed_rc: "US Fed R&C",
  us_salt_direct: "US SaLT Direct",
  us_salt_indirect: "US SaLT Indirect",
  us_salt_itc: "US SaLT ITC",
};

// Full Gaia team list for the cross-team Assignee team dropdown; ListTeams is membership-scoped so we surface every team here.
export const GAIA_TEAM_OPTIONS: Array<{ label: string; value: string }> = [
  { label: "\u00A0", value: "\u00A0" },
  ...Object.entries(TEAM_NAME_MAP)
    .map(([value, label]) => ({ label, value }))
    .sort((a, b) => a.label.localeCompare(b.label)),
];

export const GAIAOBJECT_CATEGORIES = ["audit", "notice", "litigation"] as const;

export type GAIAOBJECT_CATEGORY = (typeof GAIAOBJECT_CATEGORIES)[number];
